import { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';

interface LayoutProps {
  children: ReactNode;
  showBreadcrumb?: boolean;
}

export default function Layout({ children, showBreadcrumb = true }: LayoutProps) {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-16">
        {showBreadcrumb && <Breadcrumb />}
        {children}
      </main>
      <Footer />
    </>
  );
}